import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75baafb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_2 = {
  key: 0,
  class: "hasdata"
}

import { getSamplingPointsNoRelations } from "@/service/samplingpoint.service";
import { FilterForm } from "@/types/filterForm.type";
import { SamplingPoint } from "@/types/samplingpoint.type";

import { computed, onMounted, reactive, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { FormInstance } from "element-plus/lib/components/form";
import { FormRules } from "element-plus/lib/tokens";
import { getMarkedDatesGallery } from "@/utils/forms/datepickers.util";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
    showResults: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  showResults: (filters: FilterForm) => Promise<void>;
}

const { t } = useI18n();
const route = useRoute();

// - combos

const samplingPoints = ref<SamplingPoint[]>([]);
const showButton = ref<boolean>(true);


// - form
const form = ref<FormInstance | null>(null);
const filterEstimation = reactive<FilterForm>({
  samplingPointId: undefined,
  parameterIds: [],
  date: [null, null],
});

const isFormComplete = computed(() => {
  return filterEstimation.samplingPointId && filterEstimation.date[0] && filterEstimation.date[1];
});

//- Estimation
let datesWithEstimations = reactive<string[]>([]);

// - form validation
const rules = reactive<FormRules>({
  samplingPointIds: [
    {
      type: "array",
      required: true,
      message: t("error.required"),
      trigger: "change",
    },
  ],
});

const disabledData = (date: Date) => {
  if (!datesWithEstimations.includes(date.toDateString())) {
    return true;
  } else {
    return false;
  }
};
// - date keys
const dateKey = ref(0);

// - VUE METHODS
/**
 * vue Hook
 */
onMounted(async () => {
  samplingPoints.value = (await getSamplingPointsNoRelations())?.data || [];
  if (route.query.point) {
    filterEstimation.samplingPointId = Number(route.query.point);
  }
});

watch(
  () => filterEstimation.samplingPointId,
  async () => {
    if (filterEstimation.samplingPointId != undefined) {
      const markes = await getMarkedDatesGallery([filterEstimation.samplingPointId], dateKey.value);
      datesWithEstimations = markes?.datesWithEstimations ?? [];
      dateKey.value = markes?.dateKey ?? dateKey.value;
    }
  }
);

/**
 * Saber cunado hay estimación
 * @param day
 */
const hasEstimatedData = (day: Date) => {
  return datesWithEstimations.includes(day.toDateString());
};

const clearFilters = () => {
  filterEstimation.samplingPointId = undefined;
  filterEstimation.parameterIds = [];
  filterEstimation.date = [null, null];
  props.showResults(filterEstimation);
};

watch(
  () => filterEstimation.date[1],
  (newDate) => {
    if (newDate && newDate.getHours() === 0 && newDate.getMinutes() === 0) {
      const adjustedDate = new Date(newDate);
      adjustedDate.setHours(23, 59, 59, 999);
      filterEstimation.date[1] = adjustedDate;
    }
  }
);

// - VUE EXPOSE
expose({
  filterEstimation,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      model: _unref(filterEstimation),
      rules: _unref(rules),
      "label-position": "top",
      ref_key: "form",
      ref: form
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "samplingPointIds",
                  label: _unref(t)('label.samplingPoints')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(filterEstimation).samplingPointId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filterEstimation).samplingPointId) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samplingPoints.value, (option) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: option.id,
                            label: option.name,
                            value: option.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "date",
                  label: _ctx.$t('label.fromDate')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_el_date_picker, {
                      "disabled-date": disabledData,
                      modelValue: _unref(filterEstimation).date[0],
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filterEstimation).date[0]) = $event)),
                      type: "datetime",
                      style: {"width":"100%"},
                      format: "YYYY-MM-DD HH:mm",
                      placeholder: "DD/MM/AAAA hh:mm",
                      key: 'from' + dateKey.value,
                      disabled: _unref(filterEstimation).samplingPointId === undefined
                    }, {
                      default: _withCtx((cell) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["cell", { current: cell.isCurrent }])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ text: true, nodata: !hasEstimatedData(cell.date) })
                          }, _toDisplayString(cell.text), 3),
                          (hasEstimatedData(cell.date))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"]))
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "date2",
                  label: _ctx.$t('label.endDate')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_el_date_picker, {
                      style: {"width":"100%"},
                      "disabled-date": disabledData,
                      modelValue: _unref(filterEstimation).date[1],
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filterEstimation).date[1]) = $event)),
                      type: "datetime",
                      format: "YYYY-MM-DD HH:mm",
                      placeholder: "DD/MM/AAAA hh:mm",
                      key: 'from' + dateKey.value,
                      disabled: _unref(filterEstimation).samplingPointId === undefined
                    }, {
                      default: _withCtx((cell) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["cell", { current: cell.isCurrent }])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ text: true, nodata: !hasEstimatedData(cell.date) })
                          }, _toDisplayString(cell.text), 3),
                          (hasEstimatedData(cell.date))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"]))
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 24,
              style: {"width":"100%","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                (showButton.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "secondary",
                      style: {"width":"100%"},
                      onClick: clearFilters
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("label.resetFilters")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 24,
              style: {"width":"100%","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                (showButton.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      style: {"width":"100%"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (props.showResults(_unref(filterEstimation)))),
                      disabled: !_unref(isFormComplete)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("label.showResults")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}
}

})